import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {HttpError} from '../../shared/api.service';
import {ModalComponent} from '../../shared/modal/modal.component';

const URL: typeof window.URL = window.URL || window['webkitURL'];

@Component({
  selector: 'pdf-modal',
  templateUrl: './pdf-modal.component.html',
  styleUrls: ['./pdf-modal.component.scss']
})
export class PdfModalComponent {

  @Input() pdf: Observable<Blob>;
  @Input() filename: string;

  @ViewChild('modal') modal: ModalComponent;
  @ViewChild('pdfFrame') pdfFrame: ElementRef;

  pdfUrl$: Observable<string>;
  loading$ = new BehaviorSubject(true);
  error$ = new BehaviorSubject<string | null>(null);

  supportsPrint = false;

  constructor(private Sanitize: DomSanitizer) {
  }

  show() {
    this.loading$.next(true);
    this.pdfUrl$ = this.pdf
      .pipe(
        map(blob => <string> this.Sanitize.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob))),
        catchError((err: HttpError) => {
          this.loading$.next(false);
          this.error$.next((err && err.code) || 'Unknown error');
          return of(null);
        }),
        tap(() => {
          this.loading$.next(false);
          setTimeout(() => {
            try {
              // tslint:disable:no-unused-expression
              // noinspection BadExpressionStatementJS
              this.pdfElement.contentWindow.print;
              // tslint:enable:no-unused-expression
              this.supportsPrint = true;
            } catch (ignored) {
            }
          }, 100);
        })
      );
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  print() {
    this.pdfElement.contentWindow.print();
  }

  hideFrame() {
    this.pdfElement.style.display = 'none';
    this.supportsPrint = false;
  }

  private get pdfElement() {
    return this.pdfFrame.nativeElement as HTMLIFrameElement;
  }
}
